import {
  TRACKING_CATEGORY,
  CITY_TRACKING_ACTION,
  LOWER_BUDGET_CLICK_ACTION,
  UPPER_BUDGET_CLICK_ACTION,
  FIND_CAR_CLICK_ACTION,
  TRACKING_OBJECT,
} from "../constants/index";
import { platform } from "GlobalEnum/Platform";
/**
 * @param {Enum} trackingObject returns tracking object for used landing page
 */

export const getUsedCarLandingTrackingObject = (
  trackingObject,
  budgetLowerLimit,
  budgetUpperLimit
) => {
  budgetLowerLimit = budgetLowerLimit || 0;
  budgetUpperLimit = budgetUpperLimit || "";
  let action = "";
  let budget = `${budgetLowerLimit}L-`;
  if (budgetUpperLimit) {
    budget = `${budget}${budgetUpperLimit}L`;
  }
  let label = `selected_price=${budget}`;
  switch (trackingObject) {
    case TRACKING_OBJECT.CITY_INPUT: {
      action = CITY_TRACKING_ACTION;
      break;
    }
    case TRACKING_OBJECT.LOWER_BUDGET: {
      action = LOWER_BUDGET_CLICK_ACTION;
      break;
    }
    case TRACKING_OBJECT.UPPER_BUDGET: {
      action = UPPER_BUDGET_CLICK_ACTION;
      break;
    }
    case TRACKING_OBJECT.FIND_CAR_CTA: {
      action = FIND_CAR_CLICK_ACTION;
      break;
    }
  }
  if (!action) {
    return {};
  }
  return {
    gaCat: TRACKING_CATEGORY,
    gaActClick: action,
    gaLblClick: `${label}|platformId=${platform.MOBILE.id}`,
    bhriguCat: TRACKING_CATEGORY,
    bhriguActClick: action,
    bhriguLblClick: label,
    trackClick: true,
  };
};

/**
 * @param {string} currentCity - currently selected city
 * @param {string} clickedCity - nearby city cliked
 * @returns{object} - tracking object for nearByCity click
 */
export const NearByCityClickTrackingObject = (currentCity, clickedCity) => {
  if (!currentCity || !clickedCity) {
    return null;
  }
  return {
    gaCat: TRACKING_CATEGORY,
    gaActClick: "ClickedCitiesNearYou",
    gaLblClick: `currentCity=${currentCity}|clickedCity=${clickedCity}`,
    bhriguCat: TRACKING_CATEGORY,
    bhriguActClick: "ClickedCitiesNearYou",
    bhriguLblClick: `currentCity=${currentCity}|clickedCity=${clickedCity}`,
    trackClick: true,
  };
};
